import React, { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const Lat_Long_check_int = () => {
    const [districts, setDistricts] = useState([]);
    const [afsoList, setAfsoList] = useState([]);
    const [fpsList, setFpsList] = useState([]);
    const [selectedDist, setSelectedDist] = useState('');
    const [selectedAfso, setSelectedAfso] = useState('');
    const [selectedFps, setSelectedFps] = useState('');
    const [details, setDetails] = useState(null);
    const [fpsDetails, setFpsDetails] = useState([]);
    const [currentStatus, setCurrentStatus] = useState('');
    const [loading, setLoading] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [message, setMessage] = useState({ code: '', msg: '' });

    useEffect(() => {
        fetchDistricts();
      
        const latMsg = sessionStorage.getItem('lat_msg');
        const latCode = sessionStorage.getItem('lat_code');
        if(latMsg && latCode) {
            setMessage({ code: latCode, msg: latMsg });
            sessionStorage.removeItem('lat_msg');
            sessionStorage.removeItem('lat_code');
        }
    }, []);

    const fetchDistricts = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_URL}/api/latlongcheck/districts`, {
                credentials: 'include'
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            setDistricts(data);
        } catch (error) {
            console.error('Error fetching districts:', error);
        }
    };

    const getAfsoOnDist = async (dist_code) => {
        try {
            const formData = new FormData();
            formData.append('dist_code', dist_code);
          
            const response = await fetch(`${process.env.REACT_APP_URL}/api/latlongcheck/GetTsoOnDist`, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
          
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
          
            const xmlText = await response.text();
          
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xmlText, "text/xml");
          
            const sourceIds = xmlDoc.getElementsByTagName("source_id");
            const sourceNames = xmlDoc.getElementsByTagName("source_name");
          
            const afsoOptions = [];
          
            for(let i = 1; i < sourceIds.length; i++) {
                const sourceId = sourceIds[i].textContent;
                const sourceName = sourceNames[i].textContent;
              
                afsoOptions.push({
                    text: sourceName,
                    value: sourceId + "/@/" + sourceName
                });
            }
          
            setAfsoList(afsoOptions);
        } catch (error) {
            console.error('Error fetching AFSO:', error);
            alert("Error during AJAX call. Please try again");
            setAfsoList([]);
        }
    };

    const getFPSOnAfso = async (from_afso, dist_code) => {
        try {
            const formData = new FormData();
            formData.append('officeCode', from_afso);
            formData.append('districtCode', dist_code);
          
            const response = await fetch(`${process.env.REACT_APP_URL}/api/latlongcheck/GetShopOnDistTSO`, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
          
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
          
            const xmlText = await response.text();
          
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xmlText, "text/xml");
          
            const fpsIds = xmlDoc.getElementsByTagName("fps_id");
            const fpsNames = xmlDoc.getElementsByTagName("fps_name");
          
            const fpsOptions = [];
          
            for(let i = 0; i < fpsIds.length; i++) {
                const fpsId = fpsIds[i].textContent;
                const fpsName = fpsNames[i].textContent;
              
                fpsOptions.push({
                    text: fpsId + "(" + fpsName + ")",
                    value: fpsId + "/@/" + fpsName
                });
            }
          
            setFpsList(fpsOptions);
        } catch (error) {
            console.error('Error fetching FPS:', error);
            alert("Error during AJAX call. Please try again");
            setFpsList([]);
        }
    };

    const removeAfso = () => {
        setAfsoList([]);
    };

    const removeFps = () => {
        setFpsList([]);
    };

    const handleDistChange = (e) => {
        const value = e.target.value;
        setSelectedDist(value);
        setSelectedAfso('');
        setSelectedFps('');
        setDetails(null);
        setFpsDetails([]);
        setCurrentStatus('');
        if(value === "") {
            return false;
        }
        const dist_code = value.split("/@/")[0];
      
        removeAfso();
        removeFps();
      
        const defaultAfso = { value: "", text: "All AFSO" };
        setAfsoList([defaultAfso]);
      
        const defaultFps = { value: "", text: "All FPS" };
        setFpsList([defaultFps]);
        getAfsoOnDist(dist_code);
    };

    const handleAfsoChange = (e) => {
        const value = e.target.value;
        setSelectedAfso(value);
        setSelectedFps('');
        setDetails(null);
        setFpsDetails([]);
        setCurrentStatus('');
        removeFps();
      
        const defaultFps = { value: "", text: "All FPS" };
        setFpsList([defaultFps]);
        if(value && selectedDist) {
            const from_afso = value.split("/@/")[0];
            const dist_code = selectedDist.split("/@/")[0];
            getFPSOnAfso(from_afso, dist_code);
        }
    };

    const handleFpsChange = (e) => {
        setSelectedFps(e.target.value);
        setDetails(null);
        setFpsDetails([]);
        setCurrentStatus('');
    };

    const detailsRq = async () => {
        setDetails(null);
      
        let dist = selectedDist;
        if((dist == null) || (dist === "")) {
            dist = "00/@/All districts";
        }
      
        let afso = selectedAfso;
        if((afso == null) || (afso === "")) {
            afso = "00/@/All Afso";
        }
      
        let fps_name = "";
        let shop_no = selectedFps;
        if((shop_no == null) || (shop_no === "")) {
            shop_no = "00/@/All FPS";
            fps_name = shop_no.split("/@/")[1];
        } else {
            fps_name = shop_no.split("/@/")[0];
        }
      
        const dist_code = dist.split("/@/")[0];
        const dist_name = dist.split("/@/")[1];
        const afso_code = afso.split("/@/")[0];
        const afso_name = afso.split("/@/")[1];
        const fps_id = shop_no.split("/@/")[0];
        setTableLoading(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_URL}/api/latlongcheck/fps-latlong-status?distCode=${dist_code}&afsoCode=${afso_code}&fpsId=${fps_id}&distName=${encodeURIComponent(dist_name)}&afsoName=${encodeURIComponent(afso_name)}&fpsName=${encodeURIComponent(fps_name)}&pagetype=1`,
                { credentials: 'include' }
            );
          
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
          
            const data = await response.json();
          
            if (!data || data.length === 0) {
                alert("There is no data");
                setDetails(null);
                return;
            }
          
            setDetails({
                data: data,
                dist_code,
                dist_name,
                afso_code,
                afso_name,
                fps_id,
                fps_name
            });
        } catch (error) {
            console.error('Error fetching details:', error);
            alert("Error during AJAX call. Please try again");
        } finally {
            setTableLoading(false);
        }
    };

    const detailsRC = async (dist_code, afso_code, fps_id, status) => {
      
        if(dist_code == null || dist_code === "" || dist_code === undefined) {
            alert("Please Select District");
            return false;
        }
        setLoading(true);
        setCurrentStatus(status);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_URL}/api/latlongcheck/fps-latlong-details?distCode=${dist_code}&afsoCode=${afso_code}&fpsId=${fps_id}&status=${status}`,
                { credentials: 'include' }
            );
          
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
          
            const data = await response.json();
          
            if (!data || data.length === 0) {
                alert("There is no data");
                setFpsDetails([]);
                return;
            }
          
            setFpsDetails(data);
            setTimeout(() => {
                const element = document.getElementById('detailsRC');
                if(element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 2000);
        } catch (error) {
            console.error('Error fetching FPS details:', error);
            alert("Error during AJAX call. Please try again");
        } finally {
            setLoading(false);
        }
    };

    const updatechange = async (id) => {
        if(!details) return;
        const lat_long = id;
        document.getElementById("lat_long").value = id;
      
        const status_val = (lat_long === "E") ? "Enable" : "Disable";
        const dist_name = details.dist_name;
        const afso_name = details.afso_name;
        const fps_name = details.fps_name;
        const verify = window.confirm("Do you want to " + status_val + " latitude and longitude for district : " + dist_name + ", Afso : " + afso_name + ", fps_name : " + fps_name);
        if(verify === false) {
            return false;
        }
        const requestData = {
            dist_code: details.dist_code,
            afso_code: details.afso_code,
            fps_id: details.fps_id,
            status: lat_long === "E" ? "Y" : "N",
            lat_long: lat_long
        };
        try {
            const response = await fetch(`${process.env.REACT_APP_URL}/api/latlongcheck/LatLongCheckAction`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                credentials: 'include',
                body: new URLSearchParams(requestData)
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const result = await response.json();
          
            if(result.code === "100") {
                sessionStorage.setItem('lat_msg', result.message);
                sessionStorage.setItem('lat_code', result.code);
                window.location.reload();
            } else {
                alert('Update failed: ' + result.message);
            }
        } catch (error) {
            console.error('Error updating status:', error);
            alert('Update failed');
        }
    };

    return (
        <div style={{ paddingBottom: '100px' }}>
            <center>
                <form name="latlong">
                    {message.msg && (
                        <table style={{ width: '60%' }}>
                            <tr className="tableheader">
                                <td>Response code</td>
                                <td>Response Message</td>
                            </tr>
                            <tr>
                                <td>{message.code}</td>
                                <td>{message.msg}</td>
                            </tr>
                        </table>
                    )}
                  
                    <input type="hidden" name="pagetype" value="1" />
                    <br /><br />
                  
                    <table style={{ width: '60%' }}>
                        <tr className="tableheader">
                            <td colSpan="6" align="center">Latitude and Longitude Check</td>
                        </tr>
                        <tr>
                            <td>District</td>
                            <td>
                                <select name="dist" value={selectedDist} onChange={handleDistChange} style={{ width: '214px' }}>
                                    <option value="">All district</option>
                                    {districts.map((district, index) => (
                                        <option key={index} value={`${district.dist_code}/@/${district.dist_name_en}`}>
                                            {district.dist_name_en}
                                        </option>
                                    ))}
                                </select>
                            </td>
                            <td>AFSO</td>
                            <td>
                                <select name="afso" value={selectedAfso} onChange={handleAfsoChange} style={{ width: '284px' }}>
                                    <option value="">All janpad</option>
                                    {afsoList.map((afso, index) => (
                                        <option key={index} value={afso.value}>{afso.text}</option>
                                    ))}
                                </select>
                            </td>
                            <td>FPS</td>
                            <td>
                                <select name="fps_id" value={selectedFps} onChange={handleFpsChange} style={{ width: '260px' }}>
                                    <option value="">All fps</option>
                                    {fpsList.map((fps, index) => (
                                        <option key={index} value={fps.value}>{fps.text}</option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="6" align="center">
                               <button type="button" onClick={detailsRq} className="button button2">GetDetails</button>
                            </td>
                        </tr>
                    </table>
                </form>
                <div id="detailsRq">
                    {tableLoading && (
                        <div align="center" id="loading" style={{ display: tableLoading ? 'block' : 'none' }}>
                            <CircularProgress />
                        </div>
                    )}
                  
                    {details && details.data && details.data.length > 0 && (
                        <form name="latlong">
                            <input type="hidden" name="dist_code" value={details.dist_code} />
                            <input type="hidden" name="afso_code" value={details.afso_code} />
                            <input type="hidden" name="fps_id" value={details.fps_id} />
                            <input type="hidden" name="dist_name" value={details.dist_name} />
                            <input type="hidden" name="afso_name" value={details.afso_name} />
                            <input type="hidden" name="fps_name" value={details.fps_name} />
                            <input type="hidden" name="lat_long" id="lat_long" value="" />
                          
                            <br />
                            <table>
                                <tr className="tableheader">
                                    <td colSpan="3">
                                        Latitude and Longitude Check details for district : {details.dist_name}, Office {details.afso_name}, FPS {details.fps_name}
                                    </td>
                                </tr>
                                {details.data.map((item, index) => (
                                    <React.Fragment key={index}>
                                        <tr className="tableheader">
                                            <td>Checked</td>
                                            <td>Unchecked</td>
                                            <td>Action</td>
                                        </tr>
                                        <tr>
                                            <td align="right">
                                                <a style={{ cursor: 'pointer' }}
                                                   onClick={() => detailsRC(details.dist_code, details.afso_code, details.fps_id, 'Y')}>
                                                    {item['checked']}
                                                </a>
                                            </td>
                                            <td align="right">
                                                <a style={{ cursor: 'pointer' }}
                                                   onClick={() => detailsRC(details.dist_code, details.afso_code, details.fps_id, 'N')}>
                                                    {item['unchecked']}
                                                </a>
                                            </td>
                                            <td align="center">
                                                <input type="checkbox" name="status" value="Y" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan="3" align="center">
                                                <button type="button" name="btn" className="button button2"
                                                       onClick={() => updatechange('E')} value="Enable" style={{ marginRight: "7px"}} >
            Enable
        </button>
                                                <button type="button" name="btn" className="button button2"
                                                       onClick={() => updatechange('D')} value="Disable"  >
            Disable
        </button>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </table>
                        </form>
                    )}
                </div>
                <div align="center" id="loadingRC" style={{ display: loading ? 'block' : 'none' }}>
                    <CircularProgress />
                </div>
                <div id="detailsRC">
                    {fpsDetails.length > 0 && (
                        <>
                            <br />
                            <table width="60%" align="center" style={{ marginBottom: '80px' }}>
                                <tr className="tableheader">
                                    <td colSpan="5">
                                        Latitude and Longitude Check {currentStatus === 'Y' ? 'Enabled' : 'Disabled'} FPS Details
                                    </td>
                                </tr>
                                <tr className="tableheader">
                                    <td>Sl No</td>
                                    <td>District</td>
                                    <td>Office</td>
                                    <td>FPS Id</td>
                                    <td>License<br/>No</td>
                                </tr>
                                {fpsDetails.map((fps, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{fps['dist_name_en']}</td>
                                        <td>{fps['afso_name_en']}</td>
                                        <td>{fps['fps_id']}</td>
                                        <td>{fps['fps_no']}</td>
                                    </tr>
                                ))}
                            </table>
                        </>
                    )}
                </div>

                <button
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    style={{
                        position: 'fixed',
                        right: '18px',
                        bottom: '18px',
                        zIndex: 9999,
                        backgroundColor: '#f1872bff',
                        color: '#100d0dff',
                        border: 'none',
                        padding: '12px 14px',
                        borderRadius: '20px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                        cursor: 'pointer'
                    }}
                    title="Back to Top"
                >
                    Top
                </button>
            </center>
        </div>
    );
};

export default Lat_Long_check_int;
